module.exports = __webpack_public_path__ + "static/media/no-smoke.bec11f31.svg";